"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoInviteApi = void 0;
var tslib_1 = require("tslib");
var http_1 = require("@wix/ambassador-social-groups-v2-auto-invite/http");
var BaseApi_1 = require("../BaseApi");
var http_2 = require("@wix/ambassador-social-groups-v1-email-invite/http");
var AutoInviteApi = /** @class */ (function (_super) {
    tslib_1.__extends(AutoInviteApi, _super);
    function AutoInviteApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoInviteApi.prototype.batchInviteByEmail = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.batchInviteByEmail(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AutoInviteApi.prototype.inviteLink = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_2.inviteLink(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AutoInviteApi.prototype.getAutoInvite = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.getAutoInvite(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AutoInviteApi.prototype.deleteAutoInvite = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.deleteAutoInvite(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AutoInviteApi.prototype.listAutoInvites = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.listAutoInvites(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    AutoInviteApi.prototype.joinWithAutoInvite = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var httpClient, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        httpClient = this.getHTTPClient();
                        return [4 /*yield*/, httpClient.request(http_1.joinWithAutoInvite(payload))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return AutoInviteApi;
}(BaseApi_1.BaseApi));
exports.AutoInviteApi = AutoInviteApi;
//# sourceMappingURL=AutoInviteApi.js.map